import React, { useState } from "react";
import CalorieFAQ from "./components/CalorieFAQ/CalorieFAQ";
import "./CalorieCalculator.css";
import CalorieContent from "./components/CalorieContent/CalorieContent";

const CalorieCalculator = () => {
  const [weight, setWeight] = useState("");
  const [weightUnit, setWeightUnit] = useState("kg");
  const [activityLevel, setActivityLevel] = useState("Moderate");
  const [goal, setGoal] = useState("Maintenance");
  const [calorieIntake, setCalorieIntake] = useState(null);

  const convertWeightToKg = (weight, unit) => {
    if (unit === "kg") return parseFloat(weight);
    if (unit === "lb") return parseFloat(weight) * 0.453592;
    if (unit === "stones") return parseFloat(weight) * 6.35029;
    return 0; // Default for invalid input
  };

  const calculateCalorieIntake = () => {
    const weightInKg = convertWeightToKg(weight, weightUnit);

    if (isNaN(weightInKg) || weightInKg <= 0) {
      setCalorieIntake("Please enter a valid weight.");
      return;
    }

    let baseCalories = 24 * weightInKg; // Rough estimate: 24 kcal per kg for basal metabolic rate (BMR)

    // Adjust base calories based on activity level
    if (activityLevel === "Sedentary") {
      baseCalories *= 1.2;
    } else if (activityLevel === "Moderate") {
      baseCalories *= 1.55;
    } else if (activityLevel === "Active") {
      baseCalories *= 1.75;
    }

    // Adjust further based on goal
    if (goal === "Weight Loss") {
      baseCalories -= 500; // Caloric deficit for weight loss
    } else if (goal === "Weight Gain") {
      baseCalories += 500; // Caloric surplus for weight gain
    }

    setCalorieIntake(baseCalories.toFixed(2));
  };

  return (
    <div className="calorie-calculator">
      <div className="bmi-calculators-wrapper">
        <div>
          <h1>Calorie Intake Calculator</h1>
          <p>
            Calculate your daily calorie needs based on your weight, activity
            level, and fitness goal.
          </p>
          <div className="input-container">
            <label htmlFor="weight">Your Weight:</label>
            <div className="weight-row">
              <input
                type="number"
                id="weight"
                value={weight}
                onChange={(e) => setWeight(e.target.value)}
                min="0"
                placeholder="Enter your weight"
              />
              <select
                id="weight-unit"
                value={weightUnit}
                onChange={(e) => setWeightUnit(e.target.value)}
              >
                <option value="kg">Kilograms (kg)</option>
                <option value="lb">Pounds (lb)</option>
                <option value="stones">Stones</option>
              </select>
            </div>
          </div>

          <div className="input-container">
            <label htmlFor="activity">Activity Level:</label>
            <select
              id="activity"
              value={activityLevel}
              onChange={(e) => setActivityLevel(e.target.value)}
            >
              <option value="Sedentary">
                Sedentary (little or no exercise)
              </option>
              <option value="Moderate">Moderate (light exercise)</option>
              <option value="Active">Active (regular exercise)</option>
            </select>
          </div>

          <div className="input-container">
            <label htmlFor="goal">Goal:</label>
            <select
              id="goal"
              value={goal}
              onChange={(e) => setGoal(e.target.value)}
            >
              <option value="Maintenance">Maintenance</option>
              <option value="Weight Loss">Weight Loss</option>
              <option value="Weight Gain">Weight Gain</option>
            </select>
          </div>

          <button onClick={calculateCalorieIntake}>
            Calculate Calorie Intake
          </button>

          {calorieIntake && (
            <div className="output">
              <h2 className="output-title">
                Recommended Daily Calorie Intake:
              </h2>
              <p className="output-value">{calorieIntake} kcal</p>
            </div>
          )}
        </div>
      </div>
      <CalorieContent />
      <CalorieFAQ />
    </div>
  );
};

export default CalorieCalculator;
